export const supportedLanguages: Record<string, string> = {
  ja: 'Japanese',
  vi: 'Vietnamese',
  en: 'English',
  id: 'Indonesian'
};
